import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { CollectionResponseDto } from '../../../store/landscapeAPI/collection/dto/response/collection-response.dto';
import { Button, Label } from '../../atoms';
import { ReportingDetailsCollectionsOrganism } from '../../organisms';
import BaseTemplate from '../BaseTemplate';

import styles from './ReportingDetailsCollectionsTemplate.module.css';

export interface ReportingDetailsCollectionsTemplateProps {
  data: CollectionResponseDto[];
  handleDeleteCollection: (id: string) => void;
}

const ReportingDetailsCollectionsTemplate: FC<
  ReportingDetailsCollectionsTemplateProps
> = ({ data, handleDeleteCollection }) => {
  const navigate = useNavigate();

  return (
    <BaseTemplate>
      <div className={styles.heading}>
        <Label content="Progress Reporting - Collections" size="lg" />
        <Button
          variant={'dark'}
          onClick={() => navigate('/reporting-details/collections/add')}
        >
          Add Collection
        </Button>
      </div>
      <ReportingDetailsCollectionsOrganism
        data={data}
        handleDeleteCollection={handleDeleteCollection}
      />
    </BaseTemplate>
  );
};

export default ReportingDetailsCollectionsTemplate;
